<template>
  <div class="tag-select-container">
    <div class="select-container">
      <span class="tag-label" :class="isDisabled && 'is-disabled'" @click="handleLabelClick">{{ $t(`${i18nPrefix}.btn.addTag`) }}</span>
    </div>
    <DialogWrapper
      close-on-cancel
      class="tag-selector"
      top="8vh"
      :title="$t(`${i18nPrefix}.title.tag`)"
      :show.sync="show"
      :loading="loading"
      @save="handleSave"
      @closed="handleClosed"
    >
      <div class="tag-container">
        <div class="count-container">
          <span>
            {{ `${$t(`${i18nPrefix}.label.searchResult`)}: ${formatBigNumber(totalCount)}` }}
            {{ `${$t(`${i18nPrefix}.label.selected`)}: ${formatBigNumber(dialogSelectedCount)}` }}
          </span>
          <el-button class="clear-btn" @click="handleClickSelected">{{ $t(`${i18nPrefix}.btn.clear`) }}</el-button>
        </div>
        <div class="selected-tag">
          <div v-for="tag in selectedTagList" v-auto-tooltip.always="getSelectedTagTip(tag)" class="tag" :key="tag.id">
            <span class="label">{{ tag.i18nName }}</span>
            <div class="cancel-btn" @click="cancelSelected(tag)">
              <i class="btn-icon el-icon-close"></i>
            </div>
          </div>
        </div>
        <div class="search-container">
          <el-input
            v-model="keywords"
            class="keywords-input"
            suffix-icon="el-icon-search"
            clearable
            :placeholder="$t('common.search')"
            @input="handleSearchTagByKeywords"
          ></el-input>
        </div>
        <div class="tag-list-container">
          <div v-infinite-scroll="infiniteLoadOthersTagList" infinite-scroll-immediate="false" infinite-scroll-distance="10" class="others-tags">
            <div
              v-for="(tag, tagIndex) in othersTagType"
              :key="tagIndex"
              class="list-item tag-item"
              :class="tag.selected && 'selected'"
            >
              <el-checkbox v-model="tag.selected" class="tag-checkbox">
                <span class="tag-name">{{ tag.i18nName }}</span>
              </el-checkbox>
            </div>
          </div>
          <el-collapse v-if="tagTypeList.length" v-model="tagCollapseActiveList" class="tag-collapse" @change="handleCollapseActiveChange">
            <el-collapse-item
              v-for="(item, index) in tagTypeList"
              class="tag-collapse-item"
              :key="index"
              :title="item.label"
              :name="item.type"
            >
              <div :ref="`tagLitRef_${item.type}`" :id="`${item.type}`" v-infinite-scroll="infiniteLoadTagList" infinite-scroll-immediate="false" infinite-scroll-distance="10" class="tag-list">
                <div
                  v-for="(tag, tagIndex) in item.tagList"
                  :key="tagIndex"
                  class="list-item tag-item"
                  :class="tag.selected && 'selected'"
                >
                  <el-checkbox v-model="tag.selected" class="tag-checkbox">
                    <span class="tag-name">{{ tag.i18nName }}</span>
                  </el-checkbox>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </DialogWrapper>
  </div>
</template>

<script>
import _ from 'lodash'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import { formatBigNumber } from '@/components/filters'

export default {
  name: 'tagSelect',
  components: {
    DialogWrapper
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    totalTagList: {
      required: true
    },
    totalTagLoader: {
      default: null
    },
    tagTypes: {
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const i18nPrefix = 'admin.application.applicantList'
    return {
      i18nPrefix,
      formatBigNumber,
      loading: true,
      show: false,
      keywords: null,
      tagLoading: true,
      tagListLoader: null,
      tagList: [],
      searchedTagList: [],
      totalCount: 0,
      canSelectedTagList: [],
      tagCollapseActiveList: [],
      tagCollapsePageMap: {},
      tagCollapseScrollName: null
    }
  },
  computed: {
    selectedCount () {
      return this.value?.length
    },
    dialogSelectedCount () {
      return _.filter(this.canSelectedTagList, 'selected').length
    },
    othersTagType () {
      return _.chain(this.tagList).filter(tag => tag.type === 'OTHERS').value()
    },
    searchedTagListMap () {
      return _.chain(this.searchedTagList).groupBy(tag => tag.type).value()
    },
    tagTypeList () {
      const vm = this
      return _.chain(this.tagList).filter(tag => tag.type !== 'OTHERS').groupBy(tag => tag.type).map((val, key) => {
        key = key.toUpperCase()

        return {
          get label () {
            return vm.$t(`admin.crm.tagTypes.${key}`)
          },
          type: key,
          order: _.indexOf(this.tagTypes, key),
          tagList: val
        }
      }).orderBy('order').value()
    },
    selectedTagList () {
      return _.filter(this.canSelectedTagList, tag => tag.selected)
    }
  },
  created () {
  },
  methods: {
    async refreshDialog () {
      if (this.totalTagLoader) {
        await this.totalTagLoader()
      }
      await this.$nextTick()
      this.keywords = null
      this.restTagCollapsePageMap()
      await this.handleSearch()
      const selectedIds = this.value || []
      _.forEach(this.canSelectedTagList, tag => {
        tag.selected = selectedIds.includes(tag.id)
      })
    },
    restTagCollapsePageMap (isInit) {
      if (isInit) {
        _.forEach(this.tagTypes, name => {
          this.tagCollapsePageMap[name] = {
            current: 1,
            size: 20,
            get startIndex () {
              return (this.current - 1) * this.size
            },
            get endIndex () {
              return this.current * this.size
            }
          }
        })
      } else {
        _.forEach(this.tagTypes, name => {
          this.tagCollapsePageMap[name].current = 1
        })
      }
    },
    handleCollapseActiveChange () {
      _.forEach(this.tagCollapseActiveList, name => {
        const tagListRef = this.$refs[`tagLitRef_${name}`]
        if (tagListRef) {
          tagListRef[0].addEventListener('scroll', this.handleScroll)
        }
      })
    },
    handleScroll (event) {
      this.tagCollapseScrollName = event.target.id
    },
    infiniteLoadTagList () {
      this.tagCollapsePageMap[this.tagCollapseScrollName].current += 1
      this.setPagedTagList()
    },
    infiniteLoadOthersTagList () {
      this.tagCollapseScrollName = 'OTHERS'
      this.tagCollapsePageMap.OTHERS.current += 1
      this.setPagedTagList()
    },
    async setPagedTagList () {
      this.loading = true
      let page = {
        current: 1,
        size: 20,
        startIndex: 0,
        endIndex: 20
      }
      if (this.tagCollapseScrollName) {
        page = this.tagCollapsePageMap[this.tagCollapseScrollName]
      }
      let searchedTagList = []
      if (this.tagCollapseScrollName) {
        searchedTagList = _.concat(searchedTagList, _.get(this.searchedTagListMap, this.tagCollapseScrollName, []))
      } else if (page.current === 1) {
        _.forEach(this.searchedTagListMap, (val, key) => {
          if (val.length) {
            searchedTagList = _.concat(searchedTagList, _.slice(val, page.startIndex, page.endIndex))
          }
        })
      } else {
        searchedTagList = this.searchedTagList
      }
      try {
        const pageData = page.current === 1 ? searchedTagList : _.slice(searchedTagList, page.startIndex, page.endIndex)
        if (page.current === 1) {
          this.tagList = pageData
        } else {
          this.tagList.push(...pageData)
        }
        await this.$nextTick()
      } finally {
        this.loading = false
      }
    },
    async handleLabelClick () {
      if (this.isDisabled) {
        return
      }
      this.show = true
      this.loading = true
      await this.refreshDialog()
      this.$nextTick(() => {
        this.loading = false
      })
    },
    handleSearchTagByKeywords () {
      if (!this.searchKeywordsDebounce) {
        this.searchKeywordsDebounce = _.debounce(this.handleSearch, 500)
      }
      this.tagCollapseScrollName = null
      this.searchKeywordsDebounce()
    },
    async handleSearch () {
      this.restTagCollapsePageMap()
      if (this.keywords) {
        this.searchedTagList = _.filter(this.canSelectedTagList, tag => tag.i18nName.toUpperCase().includes(this.keywords.toUpperCase()))
        this.tagCollapseActiveList = _.chain(this.searchedTagList).map(tag => tag.type).uniq().value()
      } else {
        this.searchedTagList = this.canSelectedTagList
      }
      this.totalCount = this.searchedTagList.length
      this.setPagedTagList()
    },
    handleClickSelected () {
      _.forEach(this.canSelectedTagList, tag => {
        tag.selected = false
      })
    },
    cancelSelected (tag) {
      tag.selected = false
    },
    getSelectedTagTip (tag) {
      if (tag.type !== 'OTHERS') {
        return `${this.$t(`admin.crm.tagTypes.${tag.type}`)}: ${tag.i18nName}`
      } else {
        return tag.i18nName
      }
    },
    handleClosed () {
      this.tagCollapseActiveList = []
      this.tagCollapseScrollName = null
    },
    handleSave () {
      const selected = this.selectedTagList
      const value = _.map(selected, tag => tag.id)
      if (!this.value) {
        this.$emit('change', value)
        this.$emit('save')
      }
      this.tagCollapseActiveList = []
      this.show = false
    }
  },
  watch: {
    totalTagList: {
      immediate: true,
      deep: true,
      handler () {
        this.canSelectedTagList = _.chain(this.totalTagList).filter(tag => !tag.isSelected).map(tag => {
          return {
            ...tag,
            selected: false
          }
        }).value()
        this.totalCount = this.canSelectedTagList.length
        this.restTagCollapsePageMap(true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-select-container {
  .select-container {
    // display: flex;

    .tag-label {
      display: inline-block;
      width: 100%;
      height: 32px;
      line-height: 32px;
      margin-left: -1px;
      padding: 0 4px;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      background: #ffffff;
      color: #232323;
      text-align: center;
      vertical-align: middle;
      cursor: pointer;
      transition: all .1s;

      &:hover {
        background-color: #0096cc;
        color: #fff;
      }

      &.is-disabled {
        color: #c0c4cc;
        border-color: #ebeef5;
        cursor: not-allowed;

        &:hover {
          border-color: #ebeef5;
          color: #c0c4cc;
          background-color: #fff;
        }
      }
    }
  }

  .tag-selector {
    .tag-container {
      margin: 30px auto 0;

      .count-container {
        margin-bottom: 14px;
        display: flex;
        justify-content: space-between;

        .clear-btn {
          padding: 0 20px;
        }
      }

      .selected-tag {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        max-height: 92px;
        overflow: auto;
        margin-bottom: -14px;

        .tag {
          margin-right: 14px;
          margin-bottom: 14px;
          padding: 8px 15px;
          border-radius: 18px;
          border: 1px solid #dddedf;
          line-height: 10px;

          .label {
            vertical-align: middle;
            line-height: 1;
          }

          .cancel-btn {
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;

            .btn-icon {
              font-size: 12px;
              margin-left: 10px;
            }
          }
        }
      }

      .search-container {
        margin-top: 15px;

        .keywords-input {
          line-height: 32px;
        }
      }

      .tag-list-container {
        max-height: 52vh;
        max-height: 52dvh;
        overflow: auto;
      }

      .list-head {
        display: flex;
        margin-top: 15px;
        align-items: center;

        .head-checkbox {
          margin-left: 5px;
        }

        .match-type {
          margin-left: 15px;
        }
      }

      .others-tags {
        max-height: 140px;
        margin-top: 15px;
        overflow: auto;
        position: relative;

        .list-item {
          padding: 0 5px;
          line-height: 24px;

          &.selected {
            background: #edfaff;
          }

          &:hover {
            background: #f5f6f5;
          }

          .tag-checkbox {
            width: 100%;
            padding: 8px 0;
          }
        }
      }

      .tag-collapse {
        margin-top: 10px;
        .tag-collapse-item {
          .tag-list {
            max-height: 220px;
            margin-top: 15px;
            overflow: auto;
            position: relative;

            .list-item {
              padding: 0 5px;

              &.selected {
                background: #edfaff;
              }

              &:hover {
                background: #f5f6f5;
              }

              .tag-checkbox {
                width: 100%;
                padding: 8px 0;
              }
            }
          }
        }
      }

      .tag-list-loading {
        position: absolute;
      }
    }

    ::v-deep {
      .el-dialog {
        margin: 0 auto 30px;
      }
    }
  }
}
</style>
